import {PRX} from "../../configs/apis";
import axios from "axios";
import Qs from "qs";

class PRXServiceLocal {
  /**
   * get operating order
   * @param {object} data
   */
  // https://penta.center/apis/PRX/diag-rule/?division=11037&active=true&pagination_class=page_number
  // total: 30
  // next: null
  // previous: null
  // items: [{id: 9, name: "TestLoading1", description: "",…}, {id: 10, name: "111", description: "",…},…]
  getDiagRule({ params, apiToken } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    //
    let ruleList = JSON.parse(sessionStorage.getItem("ruleList"));
    let exampleData = { id: 1, name: "แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19", description: "", content: '{"0":{"id":0,"parent_id":null,"label":"แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19","condition":"first","text":"ท่านมีประวัติสัมผัสใกล้ชิดกับผู้ป่วยที่รับเชื้อ Covid-19 หรือมีอาชีพที่มีโอกาสสัมผัสนักท่องเที่ยวต่างชาติ \\nหรือไม่","type":"choices","level":0,"span":4,"selected":false},"1":{"parent_id":0,"label":"ท่านมีอาการเหล่านี้หรือไม่","condition":"ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ ","type":"choices","id":1,"level":1,"span":1,"selected":false},"2":{"parent_id":0,"label":"ท่านมีอาการดังกล่าวหรือไม่","condition":"ไม่ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ","type":"choices","id":2,"level":1,"span":5,"selected":true},"3":{"parent_id":1,"label":"มีความเสี่ยงติดเชื้อ","condition":"ใช่","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":3,"level":2,"span":1,"selected":false},"4":{"parent_id":3,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที","type":"end","id":4,"level":3,"span":0,"triage_level":"hos","selected":false},"5":{"parent_id":2,"label":"ท่านมีโรคประจำตัวหรือไม่","condition":"มี","text":"ผู้ที่มีโรคประจำตัว เช่น โรคความดันโลหิตสูง โรคเบาหวาน โรคหลอดเลือดหัวใจ โรคทางเดินหายใจ\\t\\t\\t\\t","type":"choices","id":5,"level":2,"span":3,"selected":true},"6":{"parent_id":5,"label":"มีความความเสี่ยงติดเชื้อ","condition":"มี","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":6,"level":3,"span":1,"selected":false},"7":{"parent_id":5,"label":"กักตัวเอง 14 วัน","condition":"ไม่มี","text":"กักตัวเอง 14 วัน พักผ่อนให้เพียงพอดื่มน้ำมากๆๆ","type":"end","id":7,"level":3,"span":0,"triage_level":"mon","selected":true},"8":{"parent_id":6,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที นอนพักผ่อนให้เพียงพอ ดื่มน้ำมากๆๆ","type":"end","id":8,"level":4,"span":0,"triage_level":"hos","selected":false},"9":{"parent_id":2,"label":"คำแนะนำดูแลตัวเอง","condition":"ไม่มี","text":"ร่างกายท่านปกติ ช่วงนี้ควรเว้นระยะห่างทางสังคม สวมหน้ากากอนามัยเมื่อต้องออกจากบ้าน\\nล้างมือบ่อยๆ หลีกเลี่ยงบริเวณที่มีคนหนาแน่น","type":"end","id":9,"level":2,"span":0,"triage_level":"nor","selected":false}}', active: true, published: false, dirty: true, updated: "2020-03-26T09:18:24.755617Z", created: "2020-03-25T12:09:29.818471Z", division: 11038, latest_published_diag_rule: 221 };
    let items = ruleList ? ruleList : [exampleData];
    items = items.filter(item => {
      if (item.active == params.active) return item;
      return null;
    });
    // Find only active or inactive
    let query = {
      total: items.length,
      next: null,
      previous: null,
      items: items
    };
    // return this.client.get(PRX.DIAG_RULE, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    return new Promise(function (resolve, reject) {
      setTimeout(() => resolve({responseData: query, response: null}), 1);
    });
  }
  // https://penta.center/apis/PRX/division-has-user/?pagination_class=page_number
  // id: 34
  // division: {id: 11037, code: "1907080179", name: "IsHealth Test", name_en: "Test",…}
  // triage_level: "1"
  // extra: """"
  // user: 10095
  getDivisionHasUser({ params, apiToken } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    let items = [];
    items.push({
      id: 0,
      division: {
        id: 0,
        code: "0",
        name: "Anonymous Test mode",
        name_en: "Anonymous Test mode",
        name_code: "Anonymous Test mode (0)",
        type: 1,
        type_label: "ทั่วไป"
      },
      triage_level: "1",
      extra: '""',
      user: 0
    });
    let query = {
      total: items.length,
      next: null,
      previous: null,
      items: items
    };
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve({ responseData: query, response: null }), 1);
    });
    return promise;
    // return this.client.get(PRX.DIVISION_HAS_USER, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
  }
  getDivisionProfile({ params, apiToken } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    // return this.client.get(PRX.DIVISION_PROFILE, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  // TODO: CardClassify.jsx
  createDivisionHasUser({ params, apiToken, data } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    // return this.client.post(PRX.DIVISION_HAS_USER, data, {params})
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  // https://penta.center/apis/PRX/diag-rule/9/?pagination_class=page_number
  // id: 9
  // name: "TestLoading1"
  // description: ""
  // content: "{"0":{"id":0,"parent_id":null,"label":"เริ่มต้นคำถามแรก","condition":"first","text":"asd","type":"choices","level":0,"span":1},"1":{"parent_id":0,"label":"","condition":"","text":"asda","type":"end","id":1,"level":1,"span":0,"triage_level":"mon"}}"
  // active: true
  // published: true
  // dirty: false
  // updated: "2020-03-24T11:14:17.373492Z"
  // created: "2020-03-24T10:20:02.028643Z"
  // division: 11037
  // latest_published_diag_rule: 33
  getDiagRuleDetail({ params, apiToken, id } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    // let url = PRX.DIAG_RULE_DETAIL({ diagRuleId: id })
    // return this.client.get(url, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let ruleList = JSON.parse(sessionStorage.getItem("ruleList"));
    let exampleData = { id: 1, name: "แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19", description: "", content: '{"0":{"id":0,"parent_id":null,"label":"แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19","condition":"first","text":"ท่านมีประวัติสัมผัสใกล้ชิดกับผู้ป่วยที่รับเชื้อ Covid-19 หรือมีอาชีพที่มีโอกาสสัมผัสนักท่องเที่ยวต่างชาติ \\nหรือไม่","type":"choices","level":0,"span":4,"selected":false},"1":{"parent_id":0,"label":"ท่านมีอาการเหล่านี้หรือไม่","condition":"ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ ","type":"choices","id":1,"level":1,"span":1,"selected":false},"2":{"parent_id":0,"label":"ท่านมีอาการดังกล่าวหรือไม่","condition":"ไม่ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ","type":"choices","id":2,"level":1,"span":5,"selected":true},"3":{"parent_id":1,"label":"มีความเสี่ยงติดเชื้อ","condition":"ใช่","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":3,"level":2,"span":1,"selected":false},"4":{"parent_id":3,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที","type":"end","id":4,"level":3,"span":0,"triage_level":"hos","selected":false},"5":{"parent_id":2,"label":"ท่านมีโรคประจำตัวหรือไม่","condition":"มี","text":"ผู้ที่มีโรคประจำตัว เช่น โรคความดันโลหิตสูง โรคเบาหวาน โรคหลอดเลือดหัวใจ โรคทางเดินหายใจ\\t\\t\\t\\t","type":"choices","id":5,"level":2,"span":3,"selected":true},"6":{"parent_id":5,"label":"มีความความเสี่ยงติดเชื้อ","condition":"มี","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":6,"level":3,"span":1,"selected":false},"7":{"parent_id":5,"label":"กักตัวเอง 14 วัน","condition":"ไม่มี","text":"กักตัวเอง 14 วัน พักผ่อนให้เพียงพอดื่มน้ำมากๆๆ","type":"end","id":7,"level":3,"span":0,"triage_level":"mon","selected":true},"8":{"parent_id":6,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที นอนพักผ่อนให้เพียงพอ ดื่มน้ำมากๆๆ","type":"end","id":8,"level":4,"span":0,"triage_level":"hos","selected":false},"9":{"parent_id":2,"label":"คำแนะนำดูแลตัวเอง","condition":"ไม่มี","text":"ร่างกายท่านปกติ ช่วงนี้ควรเว้นระยะห่างทางสังคม สวมหน้ากากอนามัยเมื่อต้องออกจากบ้าน\\nล้างมือบ่อยๆ หลีกเลี่ยงบริเวณที่มีคนหนาแน่น","type":"end","id":9,"level":2,"span":0,"triage_level":"nor","selected":false}}', active: true, published: false, dirty: true, updated: "2020-03-26T09:18:24.755617Z", created: "2020-03-25T12:09:29.818471Z", division: 11038, latest_published_diag_rule: 221 };
    let items = ruleList ? ruleList : [exampleData];
    items = items.find(element => element.id == id);
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve({ responseData: items, response: null }), 1);
    });
    return promise;
  }
  postDiagRule({ params, data, apiToken } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    // return this.client.post(PRX.DIAG_RULE, data, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let previousRuleList = JSON.parse(sessionStorage.getItem("ruleList"));
    let exampleData = { id: 1, name: "แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19", description: "", content: '{"0":{"id":0,"parent_id":null,"label":"แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19","condition":"first","text":"ท่านมีประวัติสัมผัสใกล้ชิดกับผู้ป่วยที่รับเชื้อ Covid-19 หรือมีอาชีพที่มีโอกาสสัมผัสนักท่องเที่ยวต่างชาติ \\nหรือไม่","type":"choices","level":0,"span":4,"selected":false},"1":{"parent_id":0,"label":"ท่านมีอาการเหล่านี้หรือไม่","condition":"ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ ","type":"choices","id":1,"level":1,"span":1,"selected":false},"2":{"parent_id":0,"label":"ท่านมีอาการดังกล่าวหรือไม่","condition":"ไม่ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ","type":"choices","id":2,"level":1,"span":5,"selected":true},"3":{"parent_id":1,"label":"มีความเสี่ยงติดเชื้อ","condition":"ใช่","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":3,"level":2,"span":1,"selected":false},"4":{"parent_id":3,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที","type":"end","id":4,"level":3,"span":0,"triage_level":"hos","selected":false},"5":{"parent_id":2,"label":"ท่านมีโรคประจำตัวหรือไม่","condition":"มี","text":"ผู้ที่มีโรคประจำตัว เช่น โรคความดันโลหิตสูง โรคเบาหวาน โรคหลอดเลือดหัวใจ โรคทางเดินหายใจ\\t\\t\\t\\t","type":"choices","id":5,"level":2,"span":3,"selected":true},"6":{"parent_id":5,"label":"มีความความเสี่ยงติดเชื้อ","condition":"มี","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":6,"level":3,"span":1,"selected":false},"7":{"parent_id":5,"label":"กักตัวเอง 14 วัน","condition":"ไม่มี","text":"กักตัวเอง 14 วัน พักผ่อนให้เพียงพอดื่มน้ำมากๆๆ","type":"end","id":7,"level":3,"span":0,"triage_level":"mon","selected":true},"8":{"parent_id":6,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที นอนพักผ่อนให้เพียงพอ ดื่มน้ำมากๆๆ","type":"end","id":8,"level":4,"span":0,"triage_level":"hos","selected":false},"9":{"parent_id":2,"label":"คำแนะนำดูแลตัวเอง","condition":"ไม่มี","text":"ร่างกายท่านปกติ ช่วงนี้ควรเว้นระยะห่างทางสังคม สวมหน้ากากอนามัยเมื่อต้องออกจากบ้าน\\nล้างมือบ่อยๆ หลีกเลี่ยงบริเวณที่มีคนหนาแน่น","type":"end","id":9,"level":2,"span":0,"triage_level":"nor","selected":false}}', active: true, published: false, dirty: true, updated: "2020-03-26T09:18:24.755617Z", created: "2020-03-25T12:09:29.818471Z", division: 11038, latest_published_diag_rule: 221 };
    let items = previousRuleList ? previousRuleList : [exampleData];
    let idArray = items.map(item => item.id);
    let max_c = Math.max.apply(Math, idArray);
    let newId = max_c + 1;
    //
    data["id"] = newId;
    data["description"] = "";
    data["active"] = true;
    data["published"] = false;
    data["dirty"] = true;
    data["updated"] = "today";
    data["created"] = "today";
    data["latest_published_diag_rule"] = null;
    items.push(data);
    sessionStorage.setItem("ruleList", JSON.stringify(items));
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve({ responseData: { id: newId }, response: null }), 1);
    });
    return promise;
  }
  patchDiagRuleDetail({ params, data, apiToken, id } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    // let url = PRX.DIAG_RULE_DETAIL({ diagRuleId: id })
    // return this.client.patch(url, data, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let previousRuleList = JSON.parse(sessionStorage.getItem("ruleList"));
    let exampleData = { id: 1, name: "แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19", description: "", content: '{"0":{"id":0,"parent_id":null,"label":"แบบคัดกรองตนเอง สำหรับผู้สงสัยเชื้อไวรัส Covid-19","condition":"first","text":"ท่านมีประวัติสัมผัสใกล้ชิดกับผู้ป่วยที่รับเชื้อ Covid-19 หรือมีอาชีพที่มีโอกาสสัมผัสนักท่องเที่ยวต่างชาติ \\nหรือไม่","type":"choices","level":0,"span":4,"selected":false},"1":{"parent_id":0,"label":"ท่านมีอาการเหล่านี้หรือไม่","condition":"ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ ","type":"choices","id":1,"level":1,"span":1,"selected":false},"2":{"parent_id":0,"label":"ท่านมีอาการดังกล่าวหรือไม่","condition":"ไม่ใช่","text":"มีไข้สูงมากกว่า 37.5 องศา, ไอ เจ็บคอ, ครั่นเนื้อครั่นตัว, อ่อนเพลีย, หายใจเหนื่อยหอบ","type":"choices","id":2,"level":1,"span":5,"selected":true},"3":{"parent_id":1,"label":"มีความเสี่ยงติดเชื้อ","condition":"ใช่","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":3,"level":2,"span":1,"selected":false},"4":{"parent_id":3,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที","type":"end","id":4,"level":3,"span":0,"triage_level":"hos","selected":false},"5":{"parent_id":2,"label":"ท่านมีโรคประจำตัวหรือไม่","condition":"มี","text":"ผู้ที่มีโรคประจำตัว เช่น โรคความดันโลหิตสูง โรคเบาหวาน โรคหลอดเลือดหัวใจ โรคทางเดินหายใจ\\t\\t\\t\\t","type":"choices","id":5,"level":2,"span":3,"selected":true},"6":{"parent_id":5,"label":"มีความความเสี่ยงติดเชื้อ","condition":"มี","text":"ท่านมีอาการเหล่านี้มาช่วงเวลาหนึ่งแล้วใช่หรือไม่","type":"choices","id":6,"level":3,"span":1,"selected":false},"7":{"parent_id":5,"label":"กักตัวเอง 14 วัน","condition":"ไม่มี","text":"กักตัวเอง 14 วัน พักผ่อนให้เพียงพอดื่มน้ำมากๆๆ","type":"end","id":7,"level":3,"span":0,"triage_level":"mon","selected":true},"8":{"parent_id":6,"label":"ควรปรึกษาแพทย์ทันที","condition":"ใช่","text":"ควรปรึกษาแพทย์ทันที นอนพักผ่อนให้เพียงพอ ดื่มน้ำมากๆๆ","type":"end","id":8,"level":4,"span":0,"triage_level":"hos","selected":false},"9":{"parent_id":2,"label":"คำแนะนำดูแลตัวเอง","condition":"ไม่มี","text":"ร่างกายท่านปกติ ช่วงนี้ควรเว้นระยะห่างทางสังคม สวมหน้ากากอนามัยเมื่อต้องออกจากบ้าน\\nล้างมือบ่อยๆ หลีกเลี่ยงบริเวณที่มีคนหนาแน่น","type":"end","id":9,"level":2,"span":0,"triage_level":"nor","selected":false}}', active: true, published: false, dirty: true, updated: "2020-03-26T09:18:24.755617Z", created: "2020-03-25T12:09:29.818471Z", division: 11038, latest_published_diag_rule: 221 };
    let items = previousRuleList ? previousRuleList : [exampleData];
    let found_item = items.find(element => element.id == id);
    let index_array = items.indexOf(found_item);
    for (var key in data) {
      found_item[key] = data[key];
    }
    items[index_array] = found_item;
    sessionStorage.setItem("ruleList", JSON.stringify(items));
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve({ responseData: found_item, response: null }), 1);
    });
    return promise;
  }
  postPublishedDiagRule({ params, data, apiToken } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    // return this.client.post(PRX.PUBLISHED_DIAG_RULE, data, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  patchPublishedDiagRule({ params, data, apiToken, id } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    // let url = PRX.PUBLISHED_DIAG_RULE_DETAIL({ publishedDiagRuleId: id })
    // return this.client.patch(url, data, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  getTriageLevelClassify({ params, apiToken } = {}) {
    // if (apiToken){
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken
    // }
    let axiosWithoutToken = axios.create({
      paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" })
    });
    // this.axiosWithoutToken.interceptors.request.use(this._interceptRequest, error => Promise.reject(error));
    // // intercept a response error (500) and error
    // this.axiosWithoutToken.interceptors.response.use(res => {
    //   return res
    // }, this._handleError);
    return axiosWithoutToken
      .get(PRX.TRIAGE_LEVEL_CLASSIFY, { params })
      .then(this.handleResponse)
      .catch(this.throwErrorMessage);
  }
  getLatestChatChannel({ params, apiToken } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // return this.client
    //   .get(PRX.LATEST_CHAT_CHANNEL, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  getChatChannelMessageList({ params, apiToken, chatChannelId } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // let url = PRX.CHAT_CHANNEL_MESSAGE_LIST({ chatChannelId });
    // return this.client
    //   .get(url, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  getMessageFromURL({ params, apiToken, url } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // return this.client
    //   .get(url, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  postChatChannelMessage({ params, data, apiToken, chatChannelId } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // let url = PRX.CHAT_CHANNEL_MESSAGE_POST({ chatChannelId });
    // return this.client
    //   .post(url, data, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  getEncounterTriage({ params, apiToken } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // return this.client
    //   .get(PRX.ENCOUNTER_TRIAGE, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  geNurseNoteList({ params, apiToken } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // return this.client
    //   .get(PRX.NURSE_NOTE_LIST, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  geProgressNoteList({ params, apiToken } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // return this.client
    //   .get(PRX.PROGRESS_NOTE_LIST, { params })
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
  getPatient({ params, apiToken } = {}) {
    // if (apiToken) {
    //   this.client.defaults.headers["Authorization"] = "Token " + apiToken;
    // }
    // return this.client.get(PRX.PATIENT, {params})
    //   .then(this.handleResponse)
    //   .catch(this.throwErrorMessage);
    let query = {};
    let promise = new Promise(function(resolve, reject) {
      setTimeout(() => resolve(query), 1);
    });
    return promise;
  }
}
export default PRXServiceLocal;
